import { jsx as o } from "react/jsx-runtime";
import { ThemeProvider as m } from "@lokalise/styled";
const d = ({ theme: r, children: e }) => /* @__PURE__ */ o(m, { theme: r, children: e });
export {
  d as ThemeProvider
};
//# sourceMappingURL=ThemeProvider.js.map
